var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"popupComponent":_vm.popupComponent,"basic-data":_vm.basicData,"title":"Extra Facility List","icon":"mdi-postage-stamp","addButtonText":"Extra Facility","stateendpoint":"extraFacility.extraFacilities","actions":_vm.actions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }